export const home = [
	{
		header: `Where I've Worked`,
		para: [`I’ve worked in the online space for years. Positions I’ve held include eServices specialist, social media manager, and frontend web developer. By joining these experiences together, I’m able to produce a stronger, more cohesive, product.`],
		img: `images/wireframe.jpg`,
		pullImg: "img-right",
		altText: `worked`,
		btnPara: `View Work History`,
		internalLink: true,
		link: `work-history`,
	},
	{
		header: `Things I’ve Built`,
		para: [`Here you’ll find real world examples of social media marketing, video production, and web development.`],
		img: `images/project2.png`,
		pullImg: `img-left`,
		altText: `projects`,
		btnPara: `See Projects`,
		internalLink: true,
		link: `projects`,
	},
	{
		header: `My Journey`,
		para: [`Hello Every One this is me Yamin Yasin`, `Contact me : +9203017520232`],
		img: `images/me.jpeg`,
		pullImg: `img-right`,
		altText: `Me`,
		btnPara: `Contact me`,
		internalLink: true,
		link: `youtube`,
	},
];
